export default 	[
    {
        path: '/users',
        name: 'users',
        component: () => import(
        /* webpackChunkName: "users" */ './../views/Users/List'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/new',
        name: 'users-add',
        component: () => import(
        /* webpackChunkName: "users" */ './../views/Users/Add'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/:id',
        name: 'users-edit',
        component: () => import(
        /* webpackChunkName: "users" */ './../views/Users/Edit'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/pass/:id',
        name: 'users-pass',
        component: () => import(
        /* webpackChunkName: "users" */ './../views/Users/Pass'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/pass/:id/:reset',
        name: 'users-reset',
        component: () => import(
        /* webpackChunkName: "users" */ './../views/Users/Pass'
        ),
        meta: {
            requiresAuth: true
        }
    }
]